import React from "react";
import Header from '../../component/Header/Header'
import Footer from '../../component/Footer/Footer.js';
import { FAQGroups } from "component/FAQ";
import BlockHeader from "component/BlockHeader/BlockHeader";
import Breadcrumb from "component/Breadcrumb";
import { connect } from "react-redux";
import stateMap from "store/stateMap";
import { PageCredential } from "component/PageCredential";

const PageFAQ = connect(stateMap)((props) => {
    return (
        <>
            <Header/>
                <PageCredential title="FAQ" />
                <div className="container">
                    <Breadcrumb
                        items={[
                            ['/', 'Crowdbees']
                            ,['FAQ']
                        ]}
                    />
                    <div className="mt-lg w-800 mx-auto">
                        <BlockHeader 
                            title="FAQ" 
                            desc="Frequently Asked Question"
                        />
                        <br />
                        <FAQGroups/>
                    </div>
                </div>
            <Footer/>
        </>
    )
})

export default PageFAQ;